export default __webpack_public_path__ + "static/media/back_cover.16a55717.pdf";